import * as React from 'react';

const AdvancedIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={17} fill="none">
    <path
      stroke={fillColor}
      strokeWidth={1.3}
      d="m11.986 8.81.005.01c.373.907.457 1.905.241 2.86a4.794 4.794 0 0 1-1.441 2.476 6.237 6.237 0 0 1-2.355 1.205c-.87.232-1.78.274-2.667.123l-.01-.001a5.81 5.81 0 0 1-3.412-1.819 5.672 5.672 0 0 1-1.481-3.525 6.7 6.7 0 0 1 .487-2.768 4.587 4.587 0 0 0 1.759 3.185l.013.01.014.01a1.052 1.052 0 0 0 1.611-.581l-.627-.172.627.172c.06-.218.047-.45-.037-.66l-.006-.015-.007-.015a6.64 6.64 0 0 1-.251-4.908A6.733 6.733 0 0 1 7.208.892c-.16 1.026-.065 1.882.228 2.624.34.86.921 1.502 1.521 2.046.273.247.562.484.838.71l.078.065c.305.25.595.49.867.746.54.507.98 1.045 1.246 1.726ZM7.947.491a.394.394 0 0 0-.153-.415.406.406 0 0 0-.446-.02l.6.435Z"
    />
  </svg>
);

export default AdvancedIcon;
